export const MARKETING_ANALYTICS_PRIVATE_BETA = 'RL:MarketingAnalyticsPrivateBeta';
export const UNIFIED_VISUALIZATION_PROTOTYPE = 'RaaS:UnifiedVizPrototype';
export const REPORTING_AI_INSIGHTS_SLIDER_GATE = 'reportingAI:insightSlider';